/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';
import './form.css'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput"
import ActionAdd from "../../store/action/BacklogClient/Add";
import ActionEdit from "../../store/action/BacklogClient/Edit";
import { IsEdit, IsView } from '../../store/constants'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionFetchSender from '../../store/action/Sender/FetchAll';
import Select2Multiple from "../../infra/components/formInput/SelectMultiple";
import ActionInitiateValue from "../../store/action/BacklogClient/InitiateValue";
import DatePickerInput from '../../infra/components/formInput/DatePickerInput';
import ActionGetPrefix from '../../store/action/BacklogClient/GetPrefix';
import ActionGetDetailClient from '../../store/action/BacklogClient/GetDetailClient';
class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: fromJS({
                'client-id': '',
                'sender-id': '',
                'wa-host': '',
                'webhook-dr': '',
                'webhook-interaktif': '',
                'user':'',
                'password':'',
                'token':'',
                'capability-sender':'',
                'ojk-rules':'',
                'hours-start':"",
                'hours-stop':"",
                'api-version':'',
                'phone-number':'',
                'converter':'',
                'prefix': '',
            }),
            loadded: false,
            disabled: false,
            errors: fromJS({}),
            error: '',
            capabilitySender: fromJS([]),
            ojkRules: fromJS([
                {
                    'id': '1',
                    'name': 'Yes'
                },
                {
                    'id': '2',
                    'name': 'No'
                },
            ]),
            converter: fromJS([
                {
                    'id': '1',
                    'name': 'True'
                },
                {
                    'id': '2',
                    'name': 'False'
                },
            ]),
            prefixOption: [],
            prefixDefaultValues: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        localStorage.clear();
        this.props.actionGetAllClient();
        var formVal = this.state.form;
        if (this.props.actionType === IsEdit) {
            this.setDetailView(this.props.item.get('client_id'));
        } else if (this.props.actionType === IsView) {
            this.setState({ disabled: true });
            this.setDetailView(this.props.item.get('client_id'));
        } else {
            formVal = formVal.set('converter','1').set('ojk-rules','1');
            this.getInitiateValue();
            this.getPrefix();
        }
        this.setState({form:formVal});
    }

    async setDetailView(clientId) {
        let data = await this.props.actionGetDetailClient(clientId);
        this.props.actionFetchSender(data.get('client-id'));
        var formVal = this.state.form;
        var ojkRules = '2';
        var converter = '2';
        if (this.props.item.get('ojk_rules') === true) {
            ojkRules = '1';
        }
        if (this.props.item.get('is_converter') === true) {
            converter = '1';
        }
        let dataValue = await this.props.actionInitiateValue();
        var capabilitySender = [];
        var capabilitySenderId = '';
        dataValue.get('capability-senders').map((itemvalue) => {
            if (Number(this.props.item.get('rate_limits').get('message').get('rate')) === itemvalue.get('rate') && 
                Number(this.props.item.get('rate_limits').get('message').get('interval')) === itemvalue.get('interval') && 
                Number(this.props.item.get('concurrent').get('interactive').get('$numberLong')) === itemvalue.get('concurrent')) {
                capabilitySenderId = itemvalue.get('id');
            }
            capabilitySender.push({
                'id': itemvalue.get('id'),
                'name': itemvalue.get('description')+' - rate '+itemvalue.get('rate')+', interval '+itemvalue.get('interval')+', concurrent '+itemvalue.get('concurrent'),
                'rate': itemvalue.get('rate'),
                'interval': itemvalue.get('interval'),
                'concurrent': itemvalue.get('concurrent')
            })
        });
        let dataValuePrefix =  await this.props.actionGetPrefix();
        var prefix = [];
        var prefixSelected = [];
        dataValuePrefix.map((item) => {
            prefix.push({
                'value': item.get('code'),
                'label': item.get('name')+ ' ('+item.get('code')+')'
            })
        });
        const array1 = this.props.item.get('prefix').toJS();
        const array2 = dataValuePrefix.toJS();
        const findCommonValues = (arr1, arr2) => {
            // Extract codes from both arrays
            const codesArray1 = arr1.map(item => item.code);
            const commonItems = arr2.filter(item => codesArray1.includes(item.code));
            return commonItems;
        };
          
        // Usage 
        const commonValues = findCommonValues(array1, array2);
        commonValues.map(item => {
            prefixSelected.push({
                value: item.code,
                label: item.name+ ' ('+item.code+')'
            })
        });
        formVal = formVal.set('client-id', data.get('client-id'))
            .set('sender-id', data.get('sender-id'))
            .set('wa-host', this.props.item.get('wa_host'))
            .set('webhook-dr', this.props.item.get('webhook'))
            .set('webhook-interaktif', this.props.item.get('message_webhook'))
            .set('user', this.props.item.get('user'))
            .set('api-version', this.props.item.get('api_version'))
            .set('hours-start', this.props.item.get('start'))
            .set('hours-stop', this.props.item.get('stop'))
            .set('phone-number', this.props.item.get('phone_number_id'))
            .set('token', this.props.item.get('token'))
            .set('converter', converter)
            .set('ojk-rules', ojkRules)
            .set('capability-sender', capabilitySenderId)
            .set('prefix', prefixSelected);
        this.setState({ form: formVal, capabilitySender: fromJS(capabilitySender), prefixOption: prefix, prefixDefaultValues: prefixSelected });
    }

    async getInitiateValue() {
        let data = await this.props.actionInitiateValue();
        var formVal = this.state.form;
        var capabilitySender = [];
        var capabilitySenderId = '';
        data.get('capability-senders').map((item) => {
            capabilitySenderId = item.get('id');
            capabilitySender.push({
                'id': item.get('id'),
                'name': item.get('description')+' - rate '+item.get('rate')+', interval '+item.get('interval')+', concurrent '+item.get('concurrent'),
                'rate': item.get('rate'),
                'interval': item.get('interval'),
                'concurrent': item.get('concurrent')
            })
        });
        formVal = formVal.set('wa-host', data.get('wa-host'))
            .set('hours-start', data.get('ojk-rules').get('start'))
            .set('hours-stop', data.get('ojk-rules').get('stop'))
            .set('api-version', data.get('api-version'))
            .set('capability-sender', capabilitySenderId);
        this.setState({ form: formVal, capabilitySender: fromJS(capabilitySender) });
    }

    async getPrefix() {
        let data = await this.props.actionGetPrefix();
        var prefix = [];
        data.map((item) => {
            prefix.push({
                'value': item.get('code'),
                'label': item.get('name')+ ' ('+item.get('code')+')'
            })
        });
        this.setState({ prefixOption: prefix });
    }

    // componentWillMount() {

    //     setTimeout(() => {
    //         this.props.actionFetchSender(ClientId);
    //         var formVal = this.state.form;
    //         formVal = formVal.set('client-id',ClientId).set('sender-id',SenderId);
    //         this.setState({
    //             form: formVal,
    //         })
    //     }, 3000);
    // }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    handleChange(field, value) {
        var formVal = this.state.form;

        if (field === 'client-id') {
            this.setState({ client_id: value })
            if (value == null) value = -1;
            this.props.actionFetchSender(value);
            
            formVal = formVal.set(field, value);
            this.setState({ form: formVal })
        }

        formVal = formVal.set(field, value);
        this.setState({ form: formVal})
    }

    handleChangeSelect = selectedOption => {
        var formVal = this.state.form;
        formVal = formVal.set('prefix', selectedOption);
        this.setState({ form: formVal });
    };

    validateForm() {
        let {form} = this.state;

        //validation
        if (!form.get('client-id')) {
            toast.error('Client can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('sender-id')) {
            toast.error('Sender can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('webhook-dr')) {
            toast.error('Webhook DR can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('webhook-interaktif')) {
            toast.error('Webhook Interaktif can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('user')) {
            toast.error('User can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('password') && this.props.actionType !== IsView) {
            toast.error('Password can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('token') && this.props.actionType !== IsView) {
            toast.error('Token can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('phone-number')) {
            toast.error('Phone Number can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }
    }

    async handleSubmit(dispatch) {
        const { form } = this.state;

        var clientData = this.props.clientall.find((item) => item.get('client-id') === form.get('client-id'));
        var senderData = this.props.senderall.find((item) => item.get('sender-id') === form.get('sender-id'));
        var capabilitySenderData = this.state.capabilitySender.find((item) => item.get('id') === form.get('capability-sender'));

        if(this.validateForm() === false) return false;

        let rateLimits = {
            "message":{
                "rate": capabilitySenderData.get('rate'),
                "interval": capabilitySenderData.get('interval')
            }
        }

        let concurrent = {
            "interactive": {
                "$numberLong": capabilitySenderData.get('concurrent')
            },
            "dr": {
                "$numberLong": capabilitySenderData.get('concurrent')
            }
        }

        let prefix = [];
        if (form.get('prefix') !== '') {
            form.get('prefix').map((item) => {
                var name = item.label.replace(/\s*\(\d+\)$/, "");
                prefix[name] = {
                    $numberLong: item.value,
                    isactive: true
                };
            });
        }

        let schedule = {
            "enable": (form.get('ojk-rules') === '1') ? true : false,
            "start": form.get('hours-start'),
            "stop": form.get('hours-stop')
        }

        let data = {
            "client_name": clientData.get('client-name'),
            "client_id": senderData.get('sender-name'),
            "wa_host": form.get('wa-host'),
            "webhook": form.get('webhook-dr'),
            "message_webhook": form.get('webhook-interaktif'),
            "user": form.get('user'),
            "password": form.get('password'),
            "token": form.get('token'),
            "rate_limits": rateLimits,
            "concurrent": concurrent,
            "schedule" : schedule,
            "api_version": form.get('api-version'),
            "phone_number_id": form.get('phone-number'),
            "is_converter": (form.get('converter') === '1') ? true : false,
            "prefix": prefix
        }

        // console.log(this.props.actionType,'actionType');
        
        //tutup dulu
        if (this.props.actionType === IsEdit) {
            let response = await this.props.actionEdit(data)
            if (response.ok) {
                toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
            }
        } else {
            let response = await this.props.actionAdd(data)
            if (response.ok) {
                toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
            }
        }

    }

    render() {
        const { form, errors, disabled } = this.state;
        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 required">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Client"
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 required">Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='sender-id'
                                value={form.get('sender-id')}
                                options={fromJS({
                                'source': this.props.senderall,
                                'value': 'sender-id',
                                'label': 'sender-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Sender"
                                disabled={disabled}
                                // hasError={errors.has('sender-id')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">WA Host</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'wa-host'}
                                value={form.get('wa-host')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="WA Host"
                                disabled={true}
                                hasError={errors.has('wa-host')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 required">Webhook DR</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'webhook-dr'}
                                value={form.get('webhook-dr')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Webhook DR"
                                disabled={disabled}
                                hasError={errors.has('webhook-dr')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 required">Webhook Interaktif</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'webhook-interaktif'}
                                value={form.get('webhook-interaktif')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Webhook Interaktif"
                                disabled={disabled}
                                hasError={errors.has('webhook-interaktif')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 required">User</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'user'}
                                value={form.get('user')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="User"
                                disabled={disabled}
                                hasError={errors.has('user')}
                            />
                        </div>
                    </div>
                    {this.props.actionType !== IsView && (
                        <div>
                            <div className="row no-margin-bottom">
                                <span className="col-sm-2 required">Password</span>
                                <div className="col-sm-10">
                                    <TextInputField className="form-control"
                                        field={'password'}
                                        password
                                        value={form.get('password')}
                                        onChange={(field, value) => this.handleChange(field, value)}
                                        placeholder="Password"
                                        disabled={disabled}
                                        hasError={errors.has('password')}
                                    />
                                </div>
                            </div>
                            <div className="row no-margin-bottom">
                                <span className="col-sm-2 required">Token</span>
                                <div className="col-sm-10">
                                    <TextInputField className="form-control"
                                        field={'token'}
                                        value={form.get('token')}
                                        onChange={(field, value) => this.handleChange(field, value)}
                                        placeholder="Token"
                                        disabled={disabled}
                                        hasError={errors.has('token')}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Capability Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='capability-sender'
                                value={form.get('capability-sender')}
                                options={fromJS({
                                    'source': this.state.capabilitySender,
                                    'value': 'id',
                                    'label': 'name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Capability Sender"
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">OJK Rules</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='ojk-rules'
                                value={form.get('ojk-rules')}
                                options={fromJS({
                                    'source': this.state.ojkRules,
                                    'value': 'id',
                                    'label': 'name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="OJK Rules"
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"> &nbsp; </span>
                        <div className="col-sm-12 col-md-3">
                            <label className="ml-40">Start</label>
                            <DatePickerInput
                                className="business-hour-time pl-30"
                                type="Time"
                                convertvalue
                                field="hours-start"
                                value={form.get('hours-start')}
                                dateFormat="HH:mm"
                                onChange={(field, date) => this.handleChange(field, date)}
                                placeholder='Start'
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <label className="ml-40">Stop</label>
                            <DatePickerInput
                                className="business-hour-time pl-30"
                                type="Time"
                                convertvalue
                                field="hours-stop"
                                value={form.get('hours-stop')}
                                dateFormat="HH:mm"
                                placeholder='Stop'
                                onChange={(field, date) => this.handleChange(field, date)}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">API Version</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'api-version'}
                                value={form.get('api-version')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="API Version"
                                disabled={disabled}
                                hasError={errors.has('api-version')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 required">Phone Number ID</span>
                        <div className="col-sm-10">
                            <TextInputField 
                                className="form-control"
                                field={'phone-number'}
                                value={form.get('phone-number')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Phone Number ID"
                                disabled={disabled}
                                hasError={errors.has('phone-number')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Converter</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='converter'
                                value={form.get('converter')}
                                options={fromJS({
                                    'source': this.state.converter,
                                    'value': 'id',
                                    'label': 'name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Converter"
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Prefix</span>
                        <div className="col-sm-10">
                            <Select2Multiple
                                value={form.get('prefix')}
                                onChange={this.handleChangeSelect}
                                options={this.state.prefixOption}
                                disabled={disabled}
                                defaultValue = {this.state.prefixDefaultValues}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-success"
                                value="Cancel"
                                onClick={ this.handleCancel }>
                                    Back to list
                            </button>
                            {this.props.actionType !== IsView && (
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={ this.handleSubmit }>
                                        Submit
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        );

    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            senderall: state.user.senders,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionEdit: ActionEdit,
        actionGetAllClient: ActionGetAllClient,
        actionFetchSender: ActionFetchSender,
        actionInitiateValue: ActionInitiateValue,
        actionGetPrefix: ActionGetPrefix,
        actionGetDetailClient: ActionGetDetailClient,
    }, dispatch),
)(Form);